<template>
  <v-text-field
    v-model="inputEmail"
    type="email"
    :id="id"
    required
    solo
    flat
    color="blue"
    clearable
    placeholder="例) example@lisse.co.jp"
    :style="{
      width: width + 'px'
    }"
    :rules="rules"
  ></v-text-field>
</template>

<script>
export default {
  name: 'EmailInput',
  model: { prop: 'emailText', event: 'input' },
  props: {
    emailText: { type: String },
    id: {
      type: String,
      required: false
    },
    width: {
      type: [Number, String],
      required: false,
      default: 196
    },
    rules: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    inputEmail: {
      get() {
        return this.emailText;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style scoped>
.v-toolbar {
  display: none;
}
.v-input >>> .v-input__control .v-input__slot .v-text-field__slot input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  -o-box-shadow: 0 0 0px 1000px white inset;
  -moz-box-shadow: 0 0 0px 1000px white inset;
}
.v-input >>> .v-input__control .v-input__slot {
  border-radius: 5px;
  border: solid 1px #ced6e0;
  text-align: right;
}
.v-input >>> .v-input__control .v-input__slot:before {
  display: none;
}
.v-input >>> .v-input__control .v-input__slot .v-text-field__slot input {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/_atoms/inputs/EmailInput.vue